<template lang="html">
  <div class="document-page">
    <Banner
      size="medium"
       :imageCoverURL="baseUrlStorage+data.background"
      :title="$route.params.type"
    />
    <div class="container py-5">
      <div class="content py-5">
        <div class="row mt-5">
          <div class="col-12 col-md-9">
            <div class="title-general">
              <TextDocument textType="title" textAlign="left"
                >{{data.title}}</TextDocument
              >
            </div>
            <div class="autor-place">
              <TextDocument textType="autor">{{data.autor}}</TextDocument>
              <TextDocument textType="place"
                >{{data.place}}</TextDocument
              >
            </div>
            <TextDocument textType="time">{{data.readingTime}}</TextDocument>
            <div class="ficha">
              <template
               v-for="(item, idx) in data.items"
              :key="idx"
              >
                <div class="title">
                  <TextDocument textType="subtitle"
                    >{{item.title}}</TextDocument
                  >
                </div>
                 <div class="content">
                   <TextDocument textType="normalRegular"
                  >
                   <span v-html="item.text"></span>
                   </TextDocument>
                </div>
              </template >
            </div>
          </div>
          <div class="col-12 col-md-1"></div>
          <div class="col-12 col-md-2 my-4 my-md-0">
            <ButtonsDocument />
          </div>
        </div>
        <!-- <div class="pagination">
          <ControlPagination 
            :items="data.items"
            :pag="pag"
            :total="total"
            :setPag="setPag"
          />
        </div> -->
      </div>
    </div>
    <FooterDocument />
    <Footer />
  </div>
</template>
<script>
import Banner from "../components/General/Banner.vue";
import Footer from "../components/General/Footer.vue";

import TextDocument from "../components/Document/TextDocument.vue";
import ButtonsDocument from "../components/Document/ButtonsDocument.vue";
// import ControlPagination from "../components/Document/ControlPagination.vue";

import FooterDocument from "../components/Document/FooterDocument.vue";
import { mapState, mapActions } from "vuex";
export default {
  inject: ['baseUrlStorage'],
  components: {
    Banner,
    Footer,

    TextDocument,
    ButtonsDocument,
    // ControlPagination,
    FooterDocument,
  },
  computed: {
    ...mapState({
      data: (state) => state.dataEventId,
    }),
  },
  created() {
    this.getData();
  },
  data() {
    return {
      items: [],
      pag:1,
      total:0,
      limit:3
    }
  },
  methods: {
    ...mapActions(["getDataAdmin"]),
    getData() {
     
      var _this = this;
      this.getDataAdmin({
        url: 'getEventId',
        type: "POST",
        params: { ref: this.$route.params.type, id: this.$route.query.id},
      }).then(
        (res) => {
          console.log(res.data);
          _this.data = res.data;
          this.$store.commit("SET_DATA_EVENT_ID", {
            data: res.data,
          });
        },
        (error) => {
          console.log(error);
          this.$router.replace('/')
        }
      );
    },
    setPag(pag){
      console.log(pag)
      console.log(this.data.items)
      this.pag = pag
      this.items = this.data.items.slice((pag*this.limit)-this.limit,pag*this.limit)
    }
  }
};
</script>
<style lang="css" scoped>
.document-page {
  background: #eef0f4;
}
.document-page .title-general {
  margin-bottom: 58px;
}
.document-page .autor-place {
  margin-bottom: 28px;
}
.document-page .ficha {
  margin: 30px 0;
}
.document-page .ficha .title {
  margin-bottom: 15px;
}
.document-page .ficha .content {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 10px;
}
.document-page .caso {
  margin: 30px 0;
}
.document-page .caso .title {
  margin-bottom: 15px;
}
.document-page .caso .content {
  margin-bottom: 10px;
}
.document-page .pregunta {
  margin-top: 80px;
}
.document-page .pregunta .title {
  margin-bottom: 15px;
}
.document-page .pregunta .content {
  margin-bottom: 2px;
}
.document-page .content .pagination {
  display: flex;
  justify-content: center;
  margin: 40px 0;
}
</style>
